export const marketerNewStyles = (theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    gap: "50px",
    width: "100%"
  },
  provs: {
    flex: 0.4,
  },
  zips: {
    flex: 1,
  },
  colorPanel: {
    backgroundColor: '#fafafa',
  },
  provinciaLine: {
    cursor: 'pointer',
    maxHeight: '93vh',
    overflow: 'auto',
    backgroundColor: '#fafafa',
  },
  provinciaLineChosen: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  zipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    maxHeight: '60vh',
    overflow: 'auto',
  },
  zipCard: {
    margin: '0.5em',
    backgroundColor: 'white',
    border: '1px solid black',
    borderRadius: '5px',
    padding: '1em',
  },
  zipCardChosen: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  zipMarker: {
    '&:first-child': {
      display: 'block',
      width: '1px',
      padding: '0',
      '& svg': {
        display: 'none',
      },
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  loader: {
    height: '100vh',
  },
  chip: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
})
